import Ornament from "@/components/Ornament";

export default function PageBanner({ overline, title, subtitle, testId }) {
  return (
    <section
      data-testid={testId || "page-banner"}
      className="relative pt-40 pb-20 md:pt-48 md:pb-24 bg-brand-night overflow-hidden"
    >
      {/* Atmospheric backdrop */}
      <div
        className="absolute inset-0 opacity-30"
        style={{
          background:
            "radial-gradient(ellipse at 50% 0%, rgba(107,15,26,0.4) 0%, transparent 60%), radial-gradient(ellipse at 80% 100%, rgba(201,168,76,0.15) 0%, transparent 50%)",
        }}
      />
      <div className="absolute inset-0 pointer-events-none opacity-[0.06]"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />

      <div className="relative max-w-5xl mx-auto px-6 text-center">
        {overline && (
          <div className="reveal flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-10 bg-brand-gold/60" />
            <span className="text-[11px] tracking-[0.4em] uppercase text-brand-gold font-sans">
              {overline}
            </span>
            <span className="h-px w-10 bg-brand-gold/60" />
          </div>
        )}
        <h1 className="reveal font-serif text-5xl sm:text-6xl md:text-7xl text-brand-ivory tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="reveal mt-6 font-serif italic text-lg md:text-xl text-brand-ivory/70 max-w-2xl mx-auto">
            {subtitle}
          </p>
        )}
        <div className="reveal mt-10">
          <Ornament />
        </div>
      </div>
    </section>
  );
}
